import { Alert, SimpleGrid, Skeleton, Stack, Title, Text } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { integrationsApi } from '@/api/integrations'
import { IntegrationCard } from '@/components/admin/integrations/IntegrationCard'
import { useCan } from '@/store/auth'

export function IntegrationsStatus() {
  const can = useCan()

  if (!can('usuarios', 'manage')) {
    return (
      <Alert color="yellow" title="Acesso restrito" icon={<IconAlertTriangle size={18} />}>
        Você não possui permissão para visualizar o status das integrações.
      </Alert>
    )
  }

  const { data, isLoading, isError } = useQuery({
    queryKey: ['admin-integrations-status'],
    queryFn: () => integrationsApi.getStatus(),
    staleTime: 60_000,
  })

  return (
    <Stack gap="md">
      <Stack gap={4}>
        <Title order={2}>Integrações</Title>
        <Text c="dimmed" size="sm">
          Status consolidado das integrações do ConsoleAI com sistemas externos.
        </Text>
      </Stack>

      {isLoading && (
        <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} height={220} radius="md" />
          ))}
        </SimpleGrid>
      )}

      {isError && !isLoading && (
        <Alert color="red" title="Erro" icon={<IconAlertTriangle size={18} />}>
          Falha ao carregar status das integrações.
        </Alert>
      )}

      {!isLoading && !isError && data && (
        <SimpleGrid cols={{ base: 1, md: 2 }} spacing="md">
          {data.integrations.map((integration) => (
            <IntegrationCard
              key={`${integration.integration}-${integration.scope}`}
              integration={integration}
            />
          ))}
        </SimpleGrid>
      )}
    </Stack>
  )
}
